// extracted by mini-css-extract-plugin
module.exports = {"root":"RevenueChartTooltip_root__5YvzH"};